<template>
  <section class="section" :class="classes">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="row text-center justify-content-center mb-4" v-if="filters">
              <div class="col-lg-7">
                <div class="row align-items-center pb-3">
                  <div class="col-sm-4 pb-2 pt-1 pr-auto pr-sm-0">
                    <v-select
                      class="form-control"
                      :disabled="$wait.is('titulo.load')"
                      placeholder="Gênero"
                      label="nome"
                      v-on:input="genero = $event"
                      :value="!isSyncronized ? false : genero"
                      :key="!isSyncronized ? false : genero"
                      :reduce="genero => genero.slug"
                      :options="$store.state.catalog.generos"
                    />
                  </div>
                  <div class="col-sm-4 pb-2 pt-1 pr-auto pr-sm-0">
                    <v-select
                      class="form-control"
                      :disabled="$wait.is('titulo.load')"
                      v-on:input="filtros.qualidade = $event"
                      :value="!isSyncronized ? false : filtros.qualidade"
                      :key="!isSyncronized ? false : filtros.qualidade"
                      label="nome"
                      :reduce="formato => formato.id"
                      placeholder="Qualidade"
                      :options="$store.state.catalog.formato"
                    />
                  </div>
                  <div class="col-sm-4 pb-2 pt-1">
                    <div class="input-group">
                      <v-select
                        class="form-control"
                        :disabled="$wait.is('titulo.load')"
                        placeholder="Lançamento"
                        v-model="filtros.ano"
                        :key="filtros.ano"
                        :options="$store.state.catalog.anos"
                      />
                    </div>
                  </div>
                  <div class="col-sm-8 pb-2 pt-1 pr-auto pr-sm-0">
                    <v-select
                      class="form-control"
                      :disabled="$wait.is('titulo.load')"
                      placeholder="Origem"
                      label="nome"
                      v-on:input="filtros.origem = $event"
                      :value="!isSyncronized ? false : filtros.origem"
                      :key="!isSyncronized ? false : filtros.origem"
                      :reduce="origem => origem.id"
                      :options="$store.state.catalog.origem"
                    />
                  </div>
                  <div class="col-sm-4 pb-2 pt-1 text-left">
                    <base-checkbox class="text-white" value="1" v-model="filtros.possui_elenco">
                        Elenco de Dublagem
                    </base-checkbox>
                  </div>
                </div>
              </div>
          </div>
          <div class="row justify-content-center" v-if="pagination">
            <base-pagination :total="total_titulos" :per-page="20" v-model="page" align="center" :desabilitado="$wait.is('titulo.load')"></base-pagination>
          </div>
          <v-wait for="titulo.load"> 
            <template slot="waiting">
              <div class="row row-grid">
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
                <movie-card-placeholder></movie-card-placeholder>
              </div>
            </template>
            <div class="row justify-content-center" v-if="!titulos.length">
              <div class="col-lg-7">
                <div class="card shadow bg-gradient-secondary mb-3">
                  <div class="card-body p-lg-5">
                    <h4 class="mb-1 text-center">Não foi possível encontrar nenhum título!</h4>
                    <p class="mt-0 text-center">Reduza os filtros da busca para encontrar mais títulos.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-grid" v-else>
              <movie-card v-for="titulo in titulos" :titulo="titulo" v-bind:key="titulo.id"></movie-card>
            </div>
          </v-wait>
          <div class="row justify-content-center" v-if="pagination">
            <base-pagination :total="total_titulos" :per-page="20" v-model="page" align="center" :desabilitado="$wait.is('titulo.load')"></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import movieCard from './MovieCard';
import movieCardPlaceholder from './MovieCardPlaceholder';

import BasePagination from '@/components/BasePagination';

import { mapGetters } from 'vuex';

import vSelect from 'vue-select';

export default {
  components: { movieCard, movieCardPlaceholder, BasePagination, vSelect },
  name: "movieCardDeck",
  props: {
    classes: {
      type: [String, Object, Array],
      description: "Individual card css classes"
    },
    cardClasses: {
      type: [String, Object, Array],
      description: "Individual card css classes"
    },
    pagination: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Boolean,
      default: false
    },
    procurados: {
      type: Boolean,
      default: false
    },
    seriados: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      endpoint: '/v1/titulos-recentes/',
      titulos: [],
      total_titulos: 6000,
      page: ( !this.$route.query.pagina ) ? 1 : parseInt(this.$route.query.pagina),
      termo: ( !this.$route.query.termo ) ? '' : this.$route.query.termo,
      genero: ( !this.$route.params.genero ) ? null : this.$route.params.genero,
      filtros: {
        origem: ( !this.$route.query.origem ) ? null : parseInt(this.$route.query.origem),
        ano: ( !this.$route.query.ano ) ? null : parseInt(this.$route.query.ano),
        qualidade: ( !this.$route.query.qualidade ) ? null : parseInt(this.$route.query.qualidade),
        possui_elenco: ( !this.$route.query.possui_elenco ) ? false : true,
      }
    }
  },
  computed: {
    ...mapGetters('catalog', [
        'isSyncronized',
      ])
  },
  watch: {
    page(newValue) {
      this.$router.push({ query: { ...this.$route.query, pagina: newValue }});
    },
    'genero': function(val,oldVal) {
      let route_name = 'filmes-';
      if ( this.seriados == true ){
        route_name = 'seriados-';
      }
      if ( val == null ) {
        this.$router.push({ name: route_name+'list', query: { ...this.$route.query, pagina: 1 } });
      }else {
        this.$router.push({ name: route_name+'genero-list', params: { genero: val }, query: { pagina: 1 } });
      }
    },
    'filtros.qualidade': function(newValue) {
        this.$router.push({ name: this.$route.name, query: { ...this.$route.query, qualidade: newValue || undefined }});
    },
    'filtros.origem': function(newValue) {
        this.$router.push({ name: this.$route.name, query: { ...this.$route.query, origem: newValue || undefined }});
    },
    'filtros.ano': function(newValue) {
        this.$router.push({ name: this.$route.name, query: { ...this.$route.query, ano: newValue || undefined }});
    },
    'filtros.possui_elenco': function(newValue) {
        this.$router.push({ name: this.$route.name, query: { ...this.$route.query, possui_elenco: newValue || undefined }});
    },
    '$route' (to, from) {
      this.page = ( !this.$route.query.pagina ) ? 1 : parseInt(this.$route.query.pagina)
      this.termo =  ( !this.$route.query.termo ) ? '' : this.$route.query.termo;
      this.filtros.qualidade = ( !this.$route.query.qualidade ) ? null : this.$route.query.qualidade;
      this.genero = ( !this.$route.params.genero ) ? null : this.$route.params.genero;
      this.filtros.origem = ( !this.$route.query.origem ) ? null : parseInt(this.$route.query.origem);
      this.filtros.ano = ( !this.$route.query.ano ) ? null : parseInt(this.$route.query.ano);
      this.filtros.possui_elenco = ( !this.$route.query.possui_elenco ) ? false : true;
      this.loadMovies();
    }
  },
  methods: {
    makeURLparams(data) {
      return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
    },
    async loadMovies() {

      var objQuery = {};

      let checkSearchQuery = ( this.termo !== '' ) ? true : false;
      let checkPageQuery = ( this.page > 0 ) ? true : false;
      let checkMediaTypeQuery = ( this.filtros.qualidade !== null ) ? true : false;
      let checkCategoryQuery = ( this.genero !== null ) ? true : false;
      let checkOrigemQuery = ( this.filtros.origem !== null ) ? true : false;
      let checkYearQuery = ( this.filtros.ano !== null ) ? true : false;
      let checkElencoQuery = ( this.filtros.possui_elenco !== false ) ? true : false;

      if ( this.procurados == true ) {
        this.endpoint = '/v1/titulos/';
        objQuery['procuro'] = true;
      }

      if ( this.seriados == true ) {
        this.endpoint = '/v1/seriados/';
      }

      if ( checkCategoryQuery == true ) {
        objQuery['genero__slug'] = this.genero;
      }

      if ( checkSearchQuery == true ) {
        objQuery['search'] = this.termo;
      }

      if ( checkPageQuery == true ) {
        objQuery['page'] = this.page;
      }

      if ( checkYearQuery == true ) {
        objQuery['ano'] = this.filtros.ano;
      }

      if ( checkMediaTypeQuery == true ) {
        objQuery['midias__formato'] = this.filtros.qualidade;
      }

      if ( checkOrigemQuery == true ) {
        objQuery['midias__origem'] = this.filtros.origem;
      }

      if ( checkElencoQuery == true ) {
        objQuery['elencos_dublagem'] = true;
      }

      var queryString = '?'+this.makeURLparams(objQuery);

      this.$wait.start('titulo.load');
      this.axios.get(this.endpoint+queryString)
        .then(response => {
          this.total_titulos = response.data.count;
          this.titulos = [];
          response.data.results.forEach((item) => {
              item.cover = this.axios.defaults.baseURL + item.capa;
              this.titulos.push(item);
          })
        })
        .catch(e => {
          //console.log(e.message)
        })
        .then(data => {
          this.$wait.end('titulo.load');
        }); 
      },
  },
  created() {
    this.loadMovies();
  }
};
</script>
<style>
  .v-select.form-control {
    padding-top: 0.425rem;
  }
  .v-select.vs--disabled {
    background: #e9ecef;
  }
  .vs__clear {
    margin-right: 9px;
    margin-top: -5px;
  }
</style>
